module.exports = __webpack_public_path__ + "img/toplupe.2cd8dca.png";